import { formatNumber } from './formatNumber';

// Function to multiply an input string by a given multiplier
export function multiplyString(inputString: string, multiplier: number) {
  // Parse the input string to get its numerical value
  const parsedValue = parseStringToNumber(inputString);

  // If parsing fails, return an object indicating failure
  if (parsedValue === null) {
    return {
      success: false,
      text: inputString,
      value: undefined,
    };
  }

  // Calculate the result by multiplying the parsed value with the multiplier
  const result = parsedValue * multiplier;

  // Return an object indicating success, along with the result as text and value
  return {
    success: true,
    text: formatNumber(result),
    value: result,
  };
}

// Helper function to parse different types of input strings
export function parseStringToNumber(inputString: string) {
  // Check if the input string contains a fraction
  if (inputString.includes('/')) {
    // Split the input string by whitespace to separate whole number and fraction parts
    const parts = inputString.split(' ');

    // Initialize variables to store the parsed values
    let wholeNumber = 0;
    let numerator = 0;
    let denominator = 1;

    // Handle different cases based on the number of parts
    if (parts.length === 1) {
      // Only a fraction without a whole number (e.g., '1/2')
      const fractionParts = parts[0].split('/');
      if (fractionParts.length === 2) {
        numerator = parseFloat(fractionParts[0]);
        denominator = parseFloat(fractionParts[1]);
      }
    } else if (parts.length === 2) {
      // Both whole number and fraction parts (e.g., '1 1/2')
      wholeNumber = parseInt(parts[0]);
      const fractionParts = parts[1].split('/');
      if (fractionParts.length === 2) {
        numerator = parseFloat(fractionParts[0]);
        denominator = parseFloat(fractionParts[1]);
      }
    }

    // Calculate the parsed value using the whole number and fraction parts
    const parsedValue = wholeNumber + numerator / denominator;

    // Check if the parsed value is a valid number
    if (!isNaN(parsedValue)) {
      return parsedValue;
    }
  } else {
    // If the input string is not a fraction, attempt to parse it as a floating-point number
    const parsedValue = parseFloat(inputString);
    // Check if the parsed value is a valid number
    if (!isNaN(parsedValue)) {
      // Return the parsed value
      return parsedValue;
    }
  }
  // Return null if parsing fails
  return null;
}
